import { render, staticRenderFns } from "./CellTournament.vue?vue&type=template&id=0410a204&scoped=true"
import script from "./CellTournament.vue?vue&type=script&lang=js"
export * from "./CellTournament.vue?vue&type=script&lang=js"
import style0 from "./CellTournament.vue?vue&type=style&index=0&id=0410a204&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0410a204",
  null
  
)

export default component.exports